import React from 'react';
import { Card, Typography, Empty } from 'antd';

const { Title } = Typography;

const AgentCallCenter: React.FC = () => {
  return (
    <div style={{ padding: 24, background: '#f0f2f5', minHeight: 'calc(100vh - 64px)' }}>
      <Title level={2}>Call Center</Title>
      <Card>
        <Empty description="Call center feature coming soon" />
      </Card>
    </div>
  );
};

export default AgentCallCenter;
